// extracted by mini-css-extract-plugin
module.exports = {"listText":"List_listText__Ww9Cd","listWrapper":"List_listWrapper__F_lcy","list":"List_list__M0n5r","listItem":"List_listItem__JCDgx","link":"List_link__BBX0o"};